import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaidarshanpackages() {



    const cardData = {

keyword: "Pune to Mumbai Darshan Package",

headingDescription:
    "Rising Cab Service offers comfortable and affordable Pune to Mumbai Darshan Package services for families, tourists, and corporate groups planning a full-day city sightseeing experience. Our packages include well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles with professional drivers for a safe and smooth journey. We provide flexible itineraries covering Mumbai’s top attractions with convenient pickup and drop services from Pune. With 24/7 support, transparent pricing, and reliable service, Rising Cab Service ensures a hassle-free and enjoyable Mumbai Darshan experience.",

topPlaces: [
    {
        title: "Gateway of India",
        description:
            "The Gateway of India is Mumbai’s most iconic landmark, built during the British era overlooking the Arabian Sea. It is a major tourist attraction known for its historical significance and ferry rides to Elephanta Caves. The surrounding area is lively with street performers and photographers."
    },
    {
        title: "Marine Drive",
        description:
            "Marine Drive is a famous seaside boulevard known as the Queen’s Necklace due to its sparkling night lights. It is a perfect place for evening walks, enjoying sunsets, and experiencing Mumbai’s vibrant coastal beauty."
    },
    {
        title: "Chhatrapati Shivaji Maharaj Terminus",
        description:
            "CST is a UNESCO World Heritage Site and one of Mumbai’s busiest railway stations. Its Victorian Gothic architecture, detailed carvings, and historical importance make it a must-visit landmark in the city."
    },
    {
        title: "Siddhivinayak Temple",
        description:
            "Siddhivinayak Temple is one of Mumbai’s most famous temples dedicated to Lord Ganesha. It attracts thousands of devotees daily, including celebrities and politicians, seeking blessings for success and prosperity."
    },
    {
        title: "Haji Ali Dargah",
        description:
            "Haji Ali Dargah is a beautiful mosque and tomb located on a small islet in the Arabian Sea. It is accessible via a narrow causeway and is known for its spiritual significance and stunning sea views."
    },
    {
        title: "Elephanta Caves",
        description:
            "Elephanta Caves are ancient rock-cut caves located on Elephanta Island, featuring UNESCO-listed sculptures dedicated to Lord Shiva. The caves showcase India’s rich historical and artistic heritage."
    },
    {
        title: "Colaba Causeway",
        description:
            "Colaba Causeway is a popular shopping street in South Mumbai known for fashion, accessories, antiques, and street food. It is a vibrant destination for tourists and shoppers alike."
    },
    {
        title: "Juhu Beach",
        description:
            "Juhu Beach is one of Mumbai’s most famous beaches, known for its street food stalls, sunset views, and lively atmosphere. It is a favorite spot for locals and tourists to relax and enjoy the sea breeze."
    },
    {
        title: "Worli Sea Link",
        description:
            "Bandra-Worli Sea Link is an engineering marvel connecting South Mumbai to the western suburbs. It offers stunning views of the Arabian Sea and Mumbai skyline, especially at night."
    },
    {
        title: "Sanjay Gandhi National Park",
        description:
            "Sanjay Gandhi National Park is a large protected forest area in Mumbai known for its greenery, wildlife, and the ancient Kanheri Caves. It provides a natural escape within the bustling city."
    }
],



services: [
    {
        name: "mumbai darshan one day tour package",
        description:
            "Rising Cab Service offers Mumbai Darshan One Day Tour Package for travelers who want to explore the vibrant city of Mumbai in a single day. Our well-planned itinerary covers famous attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, and other iconic landmarks. With comfortable AC cabs, experienced drivers, and flexible pickup options from Pune or Mumbai, we ensure a smooth and enjoyable sightseeing experience for families, couples, and groups."
    },
    {
        name: "Mumbai darshan package from pune",
        description:
            "Book Mumbai darshan package from pune with Rising Cab Service for a complete city tour experience. We provide reliable intercity cab services with professional drivers, well-maintained vehicles, and customized sightseeing plans covering Mumbai’s top tourist attractions. Ideal for one-day trips, weekend getaways, and family tours."
    },
    {
        name: "Mumbai darshan tour package from pune",
        description:
            "Rising Cab Service offers Mumbai darshan tour package from pune designed for comfortable and hassle-free travel. Enjoy a full-day guided sightseeing experience covering historical monuments, beaches, temples, and shopping destinations with safe and affordable cab service options."
    },
    {
        name: "Pune to Mumbai Darshan Package",
        description:
            "Our Pune to Mumbai Darshan Package provides a complete travel solution for tourists looking to explore Mumbai from Pune. We offer door-to-door pickup, AC vehicles, and experienced drivers ensuring a safe and enjoyable journey with flexible sightseeing schedules."
    },
    {
        name: "Pune to Mumbai Tour Package",
        description:
            "Rising Cab Service provides Pune to Mumbai Tour Package for families, corporate groups, and tourists. Our packages include comfortable cab travel, customizable itineraries, and visits to Mumbai’s most famous attractions for a memorable trip experience."
    },
    {
        name: "Pune to Mumbai Sightseeing Package",
        description:
            "Book Pune to Mumbai Sightseeing Package with Rising Cab Service for a relaxed and well-organized city tour. Visit major landmarks including beaches, temples, heritage sites, and entertainment spots with professional drivers and clean AC vehicles."
    },
    {
        name: "Pune to Mumbai Cab Package",
        description:
            "Rising Cab Service offers Pune to Mumbai Cab Package with affordable pricing, comfortable vehicles, and reliable intercity travel options. Perfect for one-day tours, business trips, and family travel between Pune and Mumbai."
    },
    {
        name: "Mumbai Darshan Package from Pune",
        description:
            "Our Mumbai Darshan Package from Pune is designed for travelers who want a complete sightseeing experience with safe and comfortable cab services. Enjoy flexible schedules and customizable tour options covering all major Mumbai attractions."
    },
    {
        name: "Pune to Mumbai One Day Tour",
        description:
            "Rising Cab Service provides Pune to Mumbai One Day Tour for quick and convenient travel with full-day sightseeing coverage. Our service includes experienced drivers, AC cabs, and well-planned itineraries for a hassle-free trip."
    },
    {
        name: "Pune to Mumbai City Tour Package",
        description:
            "Book Pune to Mumbai City Tour Package with Rising Cab Service for a complete exploration of Mumbai’s cultural, historical, and modern attractions with comfortable transportation and flexible travel plans."
    },
    {
        name: "Pune to Mumbai Sightseeing Cab",
        description:
            "Rising Cab Service offers Pune to Mumbai Sightseeing Cab with professional drivers and clean vehicles, ensuring a smooth journey to explore Mumbai’s top tourist destinations at your own pace."
    },
    {
        name: "Pune to Mumbai Family Tour Package",
        description:
            "Our Pune to Mumbai Family Tour Package is ideal for families looking for a comfortable and safe travel experience. We provide spacious vehicles, friendly drivers, and customized sightseeing plans."
    },
    {
        name: "Pune to Mumbai Tourist Cab Service",
        description:
            "Rising Cab Service provides Pune to Mumbai Tourist Cab Service for hassle-free travel between Pune and Mumbai with reliable drivers, flexible timing, and affordable pricing."
    },
    {
        name: "Pune to Gateway of India Tour Package",
        description:
            "Book Pune to Gateway of India Tour Package with Rising Cab Service for a scenic trip to one of Mumbai’s most iconic landmarks along with nearby attractions and guided sightseeing."
    },
    {
        name: "Pune to Marine Drive Sightseeing Package",
        description:
            "Rising Cab Service offers Pune to Marine Drive Sightseeing Package for travelers who want to enjoy the beautiful coastline, sunset views, and iconic Mumbai nightlife experience."
    },
    {
        name: "Pune to Siddhivinayak Temple Darshan Package",
        description:
            "Our Pune to Siddhivinayak Temple Darshan Package provides a peaceful and spiritual journey with comfortable cab service and priority temple visit planning for devotees."
    },
    {
        name: "Pune to Juhu Beach Tour Package",
        description:
            "Rising Cab Service provides Pune to Juhu Beach Tour Package for families and tourists to enjoy Mumbai’s famous beach destination with safe and comfortable travel arrangements."
    },
    {
        name: "Pune to Mumbai Temple Darshan Tour",
        description:
            "Book Pune to Mumbai Temple Darshan Tour with Rising Cab Service for a spiritual journey covering famous temples in Mumbai with experienced drivers and flexible travel schedules."
    }
],

tableData: [
    ["mumbai darshan one day tour package", "Mumbai darshan package from pune"],
    ["Mumbai darshan tour package from pune", "Pune to Mumbai Darshan Package"],
    ["Pune to Mumbai Tour Package", "Pune to Mumbai Sightseeing Package"],
    ["Pune to Mumbai Cab Package", "Mumbai Darshan Package from Pune"],
    ["Pune to Mumbai One Day Tour", "Pune to Mumbai City Tour Package"],
    ["Pune to Mumbai Sightseeing Cab", "Pune to Mumbai Family Tour Package"],
    ["Pune to Mumbai Tourist Cab Service", "Pune to Gateway of India Tour Package"],
    ["Pune to Marine Drive Sightseeing Package", "Pune to Siddhivinayak Temple Darshan Package"],
    ["Pune to Juhu Beach Tour Package", "Pune to Mumbai Temple Darshan Tour"]
],



whychoose: [
    {
        WhyChooseheading: "Complete Pune to Mumbai Darshan Package",
        WhyChoosedescription: "Rising Cab Service offers well-planned Pune to Mumbai Darshan Packages covering famous landmarks, religious places, beaches, historical sites, and popular attractions across Mumbai."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Sightseeing Tours",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, Tempo Travellers, and luxury vehicles to ensure a comfortable and enjoyable Mumbai sightseeing experience."
    },
    {
        WhyChooseheading: "Visit Mumbai's Top Attractions",
        WhyChoosedescription: "The package covers Gateway of India, Marine Drive, Siddhivinayak Temple, Haji Ali Dargah, Juhu Beach, Bandra-Worli Sea Link, Hanging Garden, and many other iconic locations."
    },
    {
        WhyChooseheading: "Customized Mumbai Tour Plans",
        WhyChoosedescription: "Rising Cab Service provides flexible itineraries that can be tailored according to your sightseeing preferences, family requirements, and travel schedule."
    },
    {
        WhyChooseheading: "Experienced Drivers with City Knowledge",
        WhyChoosedescription: "Our professional drivers are familiar with Mumbai's tourist attractions, routes, and traffic patterns, ensuring a smooth sightseeing journey."
    },
    {
        WhyChooseheading: "Affordable Mumbai Darshan Packages",
        WhyChoosedescription: "We provide budget-friendly Pune to Mumbai Darshan Packages with transparent pricing and excellent travel convenience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Convenient pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Pimpri Chinchwad, Pune Airport, and nearby locations."
    },
    {
        WhyChooseheading: "Perfect for Families, Tourists & Groups",
        WhyChoosedescription: "Our Mumbai Darshan Package is ideal for family vacations, educational tours, corporate outings, friend groups, and first-time visitors to Mumbai."
    }
]
};

const faqData = [
    {
        question: "What is included in the Pune to Mumbai Darshan Package?",
        answer: "The package includes cab transportation, pickup and drop services, sightseeing assistance, and visits to major tourist attractions in Mumbai."
    },
    {
        question: "Which tourist places are covered in Mumbai Darshan?",
        answer: "Popular attractions include Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, Haji Ali Dargah, Bandra-Worli Sea Link, and Hanging Garden."
    },
    {
        question: "Can I customize my Mumbai Darshan itinerary?",
        answer: "Yes, Rising Cab Service offers customized sightseeing plans according to your preferences and available time."
    },
    {
        question: "Which vehicles are available for the package?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles for sightseeing tours."
    },
    {
        question: "Is the package suitable for families?",
        answer: "Yes, the Pune to Mumbai Darshan Package is ideal for families, children, senior citizens, and group travelers."
    },
    {
        question: "Do you provide same-day Mumbai Darshan tours?",
        answer: "Yes, customers can choose same-day return packages or extended sightseeing tours based on their requirements."
    },
    {
        question: "Are the drivers familiar with Mumbai sightseeing locations?",
        answer: "Yes, our experienced drivers regularly operate Mumbai Darshan tours and know the major attractions and routes."
    },
    {
        question: "Can groups book Tempo Travellers for Mumbai Darshan?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for group tours and corporate outings."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickup services are available from Pune Airport, Railway Station, hotels, homes, and major Pune locations."
    },
    {
        question: "How can I book a Pune to Mumbai Darshan Package?",
        answer: "You can book your package through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Jagtap",
        feedback:
            "The Mumbai Darshan trip was organized exceptionally well. We visited all major attractions comfortably, and the driver guided us efficiently throughout the day.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neha Deshmukh",
        feedback:
            "Our family thoroughly enjoyed the Mumbai sightseeing tour. The vehicle was clean, spacious, and the entire journey was smooth from Pune to Mumbai and back.",
        rating: 5
    }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mumbai Darshan Package",
"image": "https://www.risingcabservice.com/assets/images/pune-to-mumbai-darshan-package.jpg",
"description": "Book Pune to Mumbai Darshan Package with Rising Cab Service for one-day city sightseeing, Mumbai tourist places visit, and comfortable outstation travel. Enjoy affordable cab packages with professional drivers and flexible travel plans.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-mumbai-darshan-package"
}
};


    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Darshan Package | One Day Mumbai Tour Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Mumbai Darshan Package for one-day Mumbai sightseeing tour. Visit famous tourist places with comfortable AC cab service, professional drivers, and affordable outstation travel from Pune."
/>

<meta
 name="keywords"
 content="mumbai darshan one day tour package, Mumbai darshan package from pune, Mumbai darshan tour package from pune, Pune to Mumbai Darshan Package, Pune to Mumbai Tour Package, Pune to Mumbai Sightseeing Package, Pune to Mumbai Cab Package, Mumbai Darshan Package"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomumbaidarshanpackages;